/**
 * Error Interceptor
 * HTTPエラーを共通処理する
 */

import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message: string;

      if (error.status === 0) {
        message = 'サーバーに接続できません。ネットワーク接続を確認してください。';
      } else if (error.status === 401) {
        message = '認証エラーが発生しました。トークンを確認してください。';
      } else if (error.status === 403) {
        message = 'アクセス権限がありません。';
      } else if (error.status === 404) {
        message = 'リソースが見つかりません。';
      } else if (error.status >= 500) {
        message = `サーバーエラーが発生しました（${error.status}）。`;
      } else {
        message = `HTTPエラーが発生しました（${error.status}）。`;
      }

      notification.showError(message);

      return throwError(() => error);
    })
  );
};
